export default __webpack_public_path__ + "static/media/logo.9f52d716.svg";